export default function activeAndSortedList(listArr) {
  const activeList = _.filter(listArr, ["attributes.active", true])
  return _.orderBy(activeList, ["attributes.position"], ["asc"])
}